"use strict"
import Vue from 'vue'
import Vuex from 'vuex'

import Vant from 'vant';
import 'vant/lib/index.css';

import router from './router'
import VueResource from 'vue-resource'
import profileStore from 'profileStore'

import directives from 'directives'
import filters from 'filters'
import Calendar from 'vue2-datepick'

import Back from 'Back'
import PopupSelect from 'PopupSelect'
import Radio from 'Radio'
import Scroll from 'Scroll'
import Popup from 'Popup'

import utils from 'utils'
import consts from 'consts'
import preview from 'vue-preview'

import "amfe-flexible"

require('sass/main.scss')

var bus = new Vue();
Vue.use(VueResource)
Vue.use(preview, {
    mainClass: 'pswp--minimal--dark',
    barsSize: { top: 0, bottom: 0 },
    captionEl: false,
    fullscreenEl: false,
    shareEl: false,
    bgOpacity: 0.85,
    tapToClose: true,
    tapToToggleControls: false
})
// 全局引入vant组件库
Vue.use(Vant);

window.http = Vue.http;
if (!window.Promise) {
    window.Promise = Vue.Promise
}
Vue.use(Vuex)
Vue.use(Calendar)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
//注册全局指令
for (let key in directives) {
    if (directives.hasOwnProperty(key)) {
        Vue.directive(key, directives[key])
    }
}
//注册全局过滤器
for (let key2 in filters) {
    if (filters.hasOwnProperty(key2)) {
        Vue.filter(key2, filters[key2])
    }
}

//注册全局组件
Vue.component('back', Back)
Vue.component('popupSelect', PopupSelect)
Vue.component('Radio', Radio)
Vue.component('Scroll', Scroll)
Vue.component('Popup', Popup)

Vue.mixin({
    created: function () {
        this.$utils = utils,
            this.$bus = bus;
        this.constant = consts;
    }
})

//添加公共请求头
Vue.http.headers.common['organizationId'] = '102';
let selectedHospital = localStorage.selectedHospital;
if (selectedHospital) {
    Vue.http.headers.common['hospitalId'] = JSON.parse(selectedHospital).hospitalId
}
Vue.http.headers.common['os'] = OS;
Vue.http.headers.common['tokenId'] = localStorage.tokenId ? localStorage.tokenId : sessionStorage.tokenId
Vue.http.headers.common['channel'] = localStorage.channel || 'WX'

let code;
//处理deviceId
if (router.currentRoute.query.code) {
    if (router.currentRoute.name !== 'pay') {
        code = router.currentRoute.query.code || sessionStorage.deviceId || localStorage.deviceId;
        localStorage.setItem('deviceId', code);
        sessionStorage.setItem('deviceId', code);
    }
} else {
    code = localStorage.deviceId || sessionStorage.deviceId
}

// let backendUrl = localStorage.backendUrl || BACKEND_URL
//请求拦截器
Vue.http.interceptors.push((request, next) => {
    request.headers.set('deviceId', localStorage.deviceId || sessionStorage.deviceId);
    request.headers.set('timestamp', String(new Date().getTime()));
    //真实数据
    if (request.url.indexOf('/app') === 0) {
        request.url = BASE_URL + request.url;
    }
    if (MOCK || request.url.indexOf('/mock') === 0) {
        request.url = '/mock/' + request.url.split('/').slice(2).join('.')
        if (request.url.indexOf('?') != -1) {
            request.url = request.url.substring(0, request.url.indexOf('?')) + '.json'
        } else {
            request.url = request.url + '.json'
        }
        // request.method = 'GET'
    }
    //处理请求超时 默认15秒超时
    let timeout, abortByNet = true;
    request.timeout = request.timeout || 25000;
    if (!request.withoutLoading)
        utils.loading((request.method.toUpperCase() === 'POST' ? 0 : 2000))

    router.beforeEach((to, from, next) => {
        request.abort();
        abortByNet = false
        next();
    })

    bus.$on('tab-change', () => {
        request.abort();
        abortByNet = false,
            bus.$off('tab-change')
    })

    timeout = setTimeout(() => {
        request.abort('timeout hehe')
        if (request.onTimeout) {
            request.onTimeout(request);
        } else {
            bus.$emit('net-error')
        }
    }, request.timeout);

    next((response) => {
        clearTimeout(timeout);
        //从response获取request参数
        if (response.body.data) {
            response.body.data.request = request;
        }
        if (!request.withoutLoading) {
            utils.loaded()
        }
        if (!request.withoutLoading && abortByNet && response.status === 0) {
            // withoutLoading为true一般说明接口只管调用不管返回，不提示此信息
            utils.alert('网络异常，请检查网络再试')
            bus.$emit('net-error');
        } else {
            //20010005跳转到登录
            if (response.body.errorCode === 20010005) {
                // 如果进入页面是首页则不跳转登录界面
                if (router.currentRoute.name === 'index' && !response.url.includes('/app/user/info')) {
                    return
                }

                //保存登录前的参数
                profileStore.commit('updateParam', {
                    namespace: 'login',
                    params: router.currentRoute.params,
                    path: router.currentRoute.path,
                    query: router.currentRoute.query
                });

                // const redirectUri = 'http://pzwjw-imts.hngwmt.com/login'
                const redirectUri = location.origin + PUBLIC_PATH + "login"
                //保证接口失败导致登录的情况获取最新code
                const codeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa2010bbda773d503&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect'
                window.location.replace(codeUrl)
                //reject promise
                return {
                    ok: false
                }
            }
        }
    });
});

//路由跳转全局钩子
//处理页面标题，支付后跳转的页面返回到首页
router.beforeEach(function (to, from, next) {
    let title = to.meta.title;
    if (title) {
        setTimeout(() => {
            document.getElementById('gwi-title').innerHTML = title;
        })
    }
    // if (profileStore.state.stateModule.popupActive && !sessionStorage.getItem('directFromPopup')) {
    //     bus.$emit('closePupup');
    //     sessionStorage.removeItem('directFromPopup')
    //     return next(false)
    // }
    next()
})

new Vue({
    router,
    store: profileStore
}).$mount('#app');

// 在本地调试环境下设置tokenId方便访问正式环境网关地址，过期需修改。 select * from USER where ID = '1000000756';
getDevToken();
function getDevToken () {
    // eslint-disable-next-line no-console
    console.log('env', process.env.NODE_ENV)
    if (process.env.NODE_ENV === "development") {
        // const __token = "296717a7cd233e8bad7035b8a8b16fc8dac310dd4820c8aab90bcc04af0216b3"
        const __token = "e9d7e191bae1586115df9b6592e31ba089ba2c169c3adad58f32de20a1a3bbde"
        localStorage.tokenId = __token
        Vue.http.headers.common['tokenId'] = __token;
    }
}



// WEBPACK FOOTER //
// ./src/main.js